import {FaHome} from 'react-icons/fa'
import {Link} from 'react-router-dom'

const NotFound = () => {
  return (
    <div className='hero'>
        <div className='text-center hero-content'>
            <div className='max-with-lg'>
                <h1 className='text-8xl font-bold mb-8'>404</h1>
                <p className='text-5xl mb-16'>Page not found!</p>
                <Link to='/' className='btn btn-primary btn-lg text-secondary'>Return home?</Link>
            </div>
        </div>

    </div>
  )
}

export default NotFound